/*eslint-disable*/
import {commonApi, common} from '@/common/index'
import {mapState} from 'vuex'

const gameMixin = {
  data() {
    return {
      picInfoList: []
    }
  },
  computed: {
    ...mapState({
      frontType: state => state.frontType
    })
  },
  methods: {
    platformPicInfo() {
      let params = {
        frontType: this.frontType,
        gameType: this.gameType
      };
      commonApi.HOMEBEFORE.platformPicInfo(params)
        .then(data => {
          this.picInfoList = data;
          let params = {
            gameType: this.gameType,
            pageNo: 1,
            pageSize: 50
          };
          return commonApi.HOMEBEFORE.gamePlatform(params)
        })
        .then(data => {
          let gameList = data.list;
          this.gameList = common.platformPicjoint(this.picInfoList, gameList)
        })
        .catch()
    }
  },
  mounted() {
    this.platformPicInfo();
  }
};

export default gameMixin



// WEBPACK FOOTER //
// ./src/common/mixins/game/gameMixin.js